<script lang="ts">
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import {getLocalization} from 'core/svelte-context/context';
    import {getLoanRequestFormContext} from '../../context';

    const localize = getLocalization();
    const {loginAndUpdateForm} = getLoanRequestFormContext();
</script>

<div class="login-first-button-container">
    <KpButton buttonStyle="warning"
              dataQa="login-first-button"
              on:click={loginAndUpdateForm}>
        {localize(/* @kp-localization commons.NejdrivePrihlasit */ 'commons.NejdrivePrihlasit')}
    </KpButton>
</div>

<style lang="less">
    .login-first-button-container {
        align-self: center;
    }
</style>